import { render, staticRenderFns } from "./TabelaDeParcelas.vue?vue&type=template&id=1fc9169c&scoped=true"
import script from "./TabelaDeParcelas.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeParcelas.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeParcelas.vue?vue&type=style&index=0&id=1fc9169c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc9169c",
  null
  
)

export default component.exports